import { IModulesPermissions } from "./rolesPermissionModel";

export interface IListParams {
  currentPage: number;
  pageSize: number;
  orderBy: string;
  searchParameter: string;
  sortType: SortingType;
}

export enum UserTypes {
  'USER' = 'User',
  'CUSTOMER' = 'Customer'
}

export enum UserColumns {
  'Id' = 'id',
  'UserName' = 'userName',
  'UserType' = 'userType',
  'CustomerName' = 'customerName',
  'CustomerId' = 'customerId',
  'ContactFirstName' = 'contactFirstName',
  'ContactSurName' = 'contactSurname',
  'CountryId' = 'countryId',
  'Country' = 'country',
  'County' = 'county',
  'Telephone' = 'telephone',
  'Email' = 'email',
  'Active' = 'active',
  'LastLoginDateTime' = 'lastLoginDateTime'
}

export enum SortingType {
  'NULL' = '',
  'ASC' = 'ASC',
  'DESC' = 'DESC'
}

export interface IUser {
  id: string;
  userName: string;
  userType: number;
  email: string;
  contactFirstName: string;
  contactSurname: string;
  telephone: string;
  active: boolean;
  lastLoginDateTime: number;
  permission: IModulesPermissions;
  jobTitle: string;
}

export interface ICustomer {
  id: string
  customerName: string
  email: string
  contactFirstName: string
  contactSurname: string
  telephone: string
  active: boolean
  customerId: string
  address1: string
  address2: string
  town: string
  city: string
  postcode: string
  countryId: string
  country: string
  county: string
}

export enum UserRole {
  // 'SuperAdmin'='1',
  'Admin' = 2,
  'Engineer' = 3,
  // 'Customer'='4',
  'Customer Service Rep' = 5,
}

export interface ICountryList {
  id: string,
  countryName: string
}

